// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container[data-v-089b68ad],.map[data-v-089b68ad]{height:100%}.map[data-v-089b68ad]{width:100%}.add-report-button[data-v-089b68ad]{position:absolute;bottom:2em;left:2em}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
